@if ( !anyErrors ) {
<div class="row">
  <div class="col-12 col-lg-6">
    <div>
      <h3>
        {{ "register.info_register_1" | translate }}
        <b>Italon</b>.
      </h3>
    </div>
    <div class="mt-3">
      <p>
        {{ "register.info_register_2" | translate }}
      </p>
    </div>
    <div class="col-12">
      <form
        class="registration-form"
        (ngSubmit)="storeRegisterForEvent()"
        [formGroup]="eventRegisterForm"
        [ngClass]="{ 'was-validated': !validate }"
      >
        <div
          class="d-flex flex-column w-100"
          *ngIf="isOWA()"
        >
          <p>{{ 'forms.choose_day' | translate }} </p>
          <div
            *ngFor="let item of eventDates; let i = index"
            class="d-flex align-items-center gap-2"
          >
            <label class="d-flex align-items-center gap-1 label-radio" for="radio-{{ i }}">
              <input
                type="radio"
                formControlName="selectDate"
                [value]="item.id"
                id="radio-{{ i }}"
                class="form-radio"
              />
              {{ item.date }} - {{ item.start }} {{ item.end }}</label
            >
            <div class="invalid-feedback">
              {{ "forms.error_mandatory_field" | translate }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-6 mb-2">
            <label for="name">{{ "forms.name" | translate }}</label>
            <input
              type="text"
              formControlName="name"
              class="form-control w-100"
            />
            <div class="invalid-feedback">
              {{ "forms.error_mandatory_field" | translate }}
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-2">
            <label for="surname">{{ "forms.surname" | translate }}</label>
            <input
              type="text"
              formControlName="surname"
              class="form-control w-100"
            />
            <div class="invalid-feedback">
              {{ "forms.error_mandatory_field" | translate }}
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-2">
            <label for="email">{{ "forms.email" | translate }}</label>
            <input
              type="text"
              formControlName="email"
              class="form-control w-100"
            />
            <div class="invalid-feedback">
              {{ "forms.error_mandatory_field" | translate }}
            </div>
          </div>
          <div class="col-12 col-lg-6 mb-2">
            <label for="phoneNumber"
              >{{ "forms.telephone" | translate }}
              <i>({{ "forms.optional" | translate }})</i></label
            >
            <input
              type="number"
              formControlName="phoneNumber"
              class="form-control w-100"
            />
          </div>
          <div class="col-12 col-lg-6 mb-2">
            <label for="profession">{{ "forms.job" | translate }}</label>
            <input
              type="text"
              formControlName="profession"
              class="form-control w-100"
            />
            <div class="invalid-feedback">
              {{ "forms.error_mandatory_field" | translate }}
            </div>
          </div>
          @if (isDealer()) {
            <div class="col-12 col-lg-6 mb-2">
              <label for="company">{{ "forms.real_company" | translate }}</label>
              <input
                type="text"
                formControlName="company"
                class="form-control w-100"
              />
              <div class="invalid-feedback">
                {{ "forms.error_mandatory_field" | translate }}
              </div>
            </div>
          } @else {
            <div class="col-12 col-lg-6 mb-2">
              <label for="company">{{ "forms.real_company" | translate }}</label>
              <input
                type="text"
                formControlName="company"
                class="form-control w-100"
              />
              <div class="invalid-feedback">
                {{ "forms.error_mandatory_field" | translate }}
              </div>
            </div>
          }
          <div class="col-12 col-lg-6 mb-2">
            <label for="city">{{ "forms.city" | translate }}</label>
            <input
              type="text"
              formControlName="city"
              class="form-control w-100"
            />
            <div class="invalid-feedback">
              {{ "forms.error_mandatory_field" | translate }}
            </div>
          </div>
          @if (isDealer()) {
            <div class="col-12 col-lg-6 mb-2">
              <label for="real_company">{{ "forms.company" | translate }}</label>
              <p>{{ realCompany }} </p>
            </div>
          }
        </div>
        <div class="row mt-4 mb-5">
          <div class="col-12 col-lg-6">
            <button class="btn btn-primary w-100" type="submit" >
              {{ "button_labels.complete_registration" | translate }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="col-12 col-lg-6">
    <div
      class="p-20 details-box-event"
      style="background-color: rgba(211, 211, 211, 0.218)"
    >
      <div>
        <h3>
          <b>{{ 'events.detail_event' | translate }}</b>
        </h3>
      </div>
      <div class="mt-3">
        <p>
          {{ eventDescription ? eventDescription : "" }}
        </p>
      </div>
      <div class="mt-3">
        <i class="icon-location-pin"></i
        ><span style="margin-left: 5px">{{ eventAddress }}</span>
      </div>
      <div class="mt-3">
        <div *ngFor="let item of eventDates">
          <i class="icon-calendar"></i
          ><span style="margin-left: 5px; margin-bottom: 5px"
            >{{ item.date }} </span
          ><span class="px-3">-</span
          ><span> {{ item.start }} {{ item.end }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
}
